// extracted by mini-css-extract-plugin
module.exports = {"header":"header__3IhT1","logo":"logo__3-ZOJ","active":"active__2kmrA"};